<div class="chart-card" *transloco="let t; prefix: 'executiveStats'">
  @if (!isLoading && !isFiltering) {
    <div class="chart-header">
      <div class="chart-title-section">
        <div class="title-and-trend">
          <h3 class="chart-title">{{ t('graphs.driverScore') }}</h3>
          @if (hasData() && !hasError) {
            <app-graph-trend-icon
              [percentageChange]="percentageDifference"
              [formattedChange]="formatPercentChange()"
              [formatValue]="formatTotalValue()"
              [isUptrendPositive]="isUptrendPositive()">
            </app-graph-trend-icon>
          }
        </div>
        <span ngbDropdown class="header-controls" [autoClose]="true">
          <button type="button" class="btn dropdown-filter form-control dropdown-toggle"
            id="driverScoreFilterDropdown" ngbDropdownToggle>
            <div class="d-flex flex-row justify-content-between dropdown-inner">
              <span class="align-middle">{{ filterLabel }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>
          <div ngbDropdownMenu aria-labelledby="driverScoreFilterDropdown">
            <div class="d-flex flex-column">
              <button class="btn btn-outline" (click)="onFilterChange('Best')" ngbDropdownItem>{{ t('driverScore.best') }}</button>
              <button class="btn btn-outline" (click)="onFilterChange('Worst')" ngbDropdownItem>{{ t('driverScore.worst') }}</button>
            </div>
          </div>
        </span>
      </div>
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="noDataTitle"></ng-container>
  }

  <ng-template #noDataTitle>
    <div class="chart-header">
      <div class="chart-title-section">
        <h3 class="chart-title">{{ t('graphs.driverScore') }}</h3>
      </div>
    </div>
  </ng-template>

  <div class="chart-body">
    @defer (on timer(100ms)) {
      @if (!isLoading && !isFiltering && hasError) {
        <div class="d-flex align-items-center justify-content-center no-data">
          <app-graph-error-state></app-graph-error-state>
        </div>
      } @else if (!isLoading && !isFiltering && hasData()) {
        <div class="chart-and-legend">
          <div class="chart-wrapper">
            <app-donut-chart
              [data]="donutData"
              [width]="150"
              [height]="150"
              [innerRadiusRatio]="0.6"
              [variableArcWidths]="false"
              [showPercentageAlways]="true"
              (segmentHover)="onSegmentHover($event)">
            </app-donut-chart>

            <div class="center-text">
              <div class="center-label">{{ t('driverScore.scoreLabel') }}</div>
              <div class="center-value" [class.hovered]="hoveredPercentage !== null">
                {{ getCenterPercentage() }}
              </div>
            </div>
          </div>

          <div class="legend-container">
            @for (item of legendItems; track item.label) {
              <div class="legend-item" [class.highlighted]="hoveredSegmentName === item.label">
                <div class="legend-indicator" [style.background-color]="item.color"></div>
                <span class="legend-label" [title]="item.label">{{ item.label }}</span>
              </div>
            }
          </div>
        </div>
      } @else if (!isLoading && !isFiltering && !hasData()) {
        <div class="d-flex align-items-center justify-content-center no-data">
          <app-empty-state></app-empty-state>
        </div>
      }
    }
  </div>

  @if (isLoading || isFiltering) {
    <div class="card-loader">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  }
</div>